import type { SVGProps } from 'react';

export const CameraIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M4.99993 3.99988H12.9999C15.0226 3.99988 16.6666 5.64388 16.6666 7.66654V16.3332C16.6666 18.3559 15.0226 19.9999 12.9999 19.9999H4.99993C2.97727 19.9999 1.33327 18.3559 1.33327 16.3332V7.66654C1.33327 5.64388 2.97727 3.99988 4.99993 3.99988ZM5.33327 9.33321C5.33327 10.0692 5.9306 10.6665 6.6666 10.6665C7.4026 10.6665 7.99993 10.0692 7.99993 9.33321C7.99993 8.59721 7.4026 7.99988 6.6666 7.99988C5.9306 7.99988 5.33327 8.59721 5.33327 9.33321ZM21.5306 6.66655C22.0506 6.37988 22.6679 6.38921 23.1813 6.69188C23.6946 6.99588 23.9999 7.53188 23.9999 8.12788V15.8719C23.9999 16.4679 23.6946 17.0039 23.1813 17.3079C22.9186 17.4625 22.6266 17.5412 22.3346 17.5412C22.0586 17.5412 21.7826 17.4719 21.5293 17.3319L18.6666 15.7572V8.24121L21.5306 6.66655Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
